import store from '../store/store';

/**
 * optional defaultValue because there are cases before bookingSessionData is set in store
 * we attempt to use this function, which resulted in an empty bookingMailboxGuid
 *
 * TODO: WI169226 refactor this to use formatBookingMailboxGuid
 */
export default function getBookingMailboxGuid(defaultValue = ''): string {
    return addDashes(store.bookingMailbox?.split('@')[0] ?? defaultValue);
}

function addDashes(uuid: string) {
    if (uuid == '') {
        return '';
    }
    return (
        uuid.substr(0, 8) +
        '-' +
        uuid.substr(8, 4) +
        '-' +
        uuid.substr(12, 4) +
        '-' +
        uuid.substr(16, 4) +
        '-' +
        uuid.substr(20)
    );
}
